export class ViewApplicationStakeholdersItamsConstants {
    static TRADERS_CONTROL_NAME = "traders";
    static TRADERS_FORM_GROUP_NAME = "tradersForm";
    static STAKEHOLDERS_HEADER = "Traders";
}
